import React, {Component} from 'react';
import {connect} from 'react-redux';
import {isEmpty} from 'lodash';
import {Modal, Button, Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import './modals.scss';

class ShowReplacementPartModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
    this.onCloseModalClick = this.onCloseModalClick.bind(this);
  }

  fetchData() {
    const {partCode} = this.props;
    this.props.fetchPartReplacement(partCode);
    this.setState({'modalWasOpen': true});
  }

  onCloseModalClick() {
    this.setState({'modalWasOpen': false});
  }

  renderLoaderOrPartReplacement() {
    const {loading} = this.props;
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderPartReplacement();
  }

  renderPartReplacement() {
    const {partReplacement} = this.props;
    if (isEmpty(partReplacement)) {
      return (
        <Table.Row>
          <Table.Cell colSpan={2}>No hay repuesto sustituto</Table.Cell>
        </Table.Row>
      );
    }

    return (
      <Table.Row>
        <Table.Cell>{partReplacement.code}</Table.Cell>
        <Table.Cell className='name-column'>{partReplacement.name}</Table.Cell>
      </Table.Row>
    );
  }

  render() {
    const {partCode} = this.props;
    const {modalWasOpen} = this.state;

    return (
      <Modal
        size='tiny'
        onOpen={() => this.fetchData()}
        className='show-substitute-replacement'
        open={modalWasOpen}
        trigger={<span className='part-code-container'>{partCode}</span>}
      >
        <Modal.Header>Repuesto sustituto</Modal.Header>

        <Modal.Content>
          <Modal.Description>
            <Table textAlign='center'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Código</Table.HeaderCell>
                  <Table.HeaderCell className='name-column'>
                    Nombre
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>{this.renderLoaderOrPartReplacement()}</Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button positive onClick={this.onCloseModalClick}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.locationsAssignment.loadingPartReplacement,
    'partReplacement': state.locationsAssignment.partReplacement,
  };
};

const {
  fetchPartReplacement,
} = Actions;

export default connect(mapStateToProps, {
  fetchPartReplacement,
})(ShowReplacementPartModal);
